window.TipoDocumentoController = ControllerBase.extend({
    name: "TipoDocumentoController",

    ajax: function() {
        return {
            url: "/Orcamento/TiposDocumento",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString(formaPagamentoData)
        };
    },

    renderizado: function() {


    }

});